import { render, staticRenderFns } from "./ProfessorGeneroCard.vue?vue&type=template&id=c05288b8&scoped=true"
import script from "./ProfessorGeneroCard.vue?vue&type=script&lang=js"
export * from "./ProfessorGeneroCard.vue?vue&type=script&lang=js"
import style0 from "./ProfessorGeneroCard.vue?vue&type=style&index=0&id=c05288b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05288b8",
  null
  
)

export default component.exports